<template>
  <div>
    <div class="pileDetail">
      <el-col :span="8" :xs="24" :lg="8">
        <el-image :src="image" />
      </el-col>
      <el-col :span="16" :xs="24" :lg="16">
        <div class="details">
          <div class="specifier">
            <h1>充电桩 160~240kw直流</h1>
            <h3>产品特征 Product Features</h3>
            <ul>
              <li>新一代恒功率直流充电模块，大电流输出可有效降低充电时间。根据不同车辆的充电需求，可进行功率智能分配，满足用户安全，快速充电的需求</li>
              <li>200~750Vdc超宽电压范围</li>
              <li>IP54防护等级，具备多充保护功能，可有效应对各种突发状况，保证用户安全充电</li>
            </ul>
          </div>
          <div class="application">
            <h3>应用领域 Application Area</h3>
            <span>适用于重卡、矿运车、电动大巴等充电站建设</span>
          </div>
        </div>
      </el-col>
    </div>
    <el-divider></el-divider>
    <div class="table">
<!--      <el-table-->
<!--        :span-method="objectSpanMethod"-->
<!--        :data="tableData"-->
<!--        style="width: 95%">-->
<!--        <el-table-column-->
<!--          prop="type"-->
<!--          label="产品分类"-->
<!--          width="360px">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c30"-->
<!--          label="160kw"-->
<!--          width="360px">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c60"-->
<!--          width="360px"-->
<!--          label="180kw">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="c90"-->
<!--          width="360px"-->
<!--          label="240kw">-->
<!--        </el-table-column>-->
<!--      </el-table>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "Pile240kw",
  data(){
    return{
      image:require('../../../assets/images/production/pile/直流桩60-120kw.jpg'),
      tableData: [
        {
          type: '输入电压',
          c30: '304~456V',
          c60: '323~437V',
          c90: '323~437V',
        },
        {
          type: '输入频率',
          c30: '45~65Hz',
          c60: '45~65Hz',
          c90: '45~65Hz',
        },
        {
          type: '输入功率因数',
          c30: '≥0.99',
          c60: '≥0.99',
          c90: '≥0.99',
        },
        {
          type: '最大输入电流',
          c30: '320A',
          c60: '360A',
          c90: '480A',
        },
        {
          type: '输出电流范围',
          c30: '0~532.8A',
          c60: '0~540A',
          c90: '0~720A',
        },
        {
          type: '输出电压范围',
          c30: '200~750V',
          c60: '200~750V',
          c90: '200~750V',
        },
        {
          type: '整机效率',
          c30: '峰值≥95%',
          c60: '峰值≥95%',
          c90: '峰值≥95%',
        },
        {
          type: '工作温度',
          c30: '-20~65℃，50℃以上降额输出',
          c60: '-20~65℃，50℃以上降额输出',
          c90: '-20~65℃，50℃以上降额输出',
        },
        {
          type: '工作湿度',
          c30: '≤95%',
          c60: '≤95%',
          c90: '≤95%',
        },

        {
          type: '海拔高度',
          c30: '≤2000m',
          c60: '≤2000m',
          c90: '≤2000m',
        },
        {
          type: '外观尺寸',
          c30: '800*450*1800',
          c60: '800*600*2100',
          c90: '800*800*2200'
        },
        {
          type: '保护功能',
          c30: '过压保护、欠压保护、过流保护、漏电保护、过温保护、防雷保护、短路保护',
          c60: '过压保护、欠压保护、过流保护、漏电保护、过温保护、防雷保护、短路保护',
          c90: '过压保护、欠压保护、过流保护、漏电保护、过温保护、防雷保护、短路保护',
        }
      ]
    }
  },
  methods:{
    objectSpanMethod({row,column,rowIndex,columnIndex}){
      //console.log(row,column,rowIndex,columnIndex)
    }
  }
}
</script>

<style lang="less" scoped>
.pileDetail{
  margin: 30px 50px;
  overflow: hidden;
  .el-image{
    float: left;
    max-height: 523.8px;
    max-width: 379.8px;
    padding: 20px 20px;
    //background-color: greenyellow;
  }
  .details{
    float: left;
    margin: 20px 0;
    .specifier{
      width: 80%;
      //background-color: pink;
      ul{
        width: 80%;
        //background-color: yellowgreen;
        li{
          list-style: none;
          &:before{
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            background-color: #2c6bb6;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }
    }
    .application{
      float: left;
      width: 85%;
      span{
        padding-left: 5px;
      }
    }
  }
  h1{
    padding: 0 5px;
    color: #2c6cb6;
  }
  h3{
    padding: 0 5px;
    color: #2c6cb6;
  }
}
.table{
  margin: 30px 50px;
}
</style>
